import { useEffect, useState } from "react";
import { decryptPayload } from "../../apis/crypto";
// @ts-ignore: missing type declarations for apimethod.js
import { API } from "../../Services/apimethod.js";
// @ts-ignore: missing type declarations for apimethod.js
import { getTokenExp,decryptData } from "@/Services/req_res_decode_encode";
import toast from "react-hot-toast";

export default function HabitsCard() {
  const [q1, setQ1] = useState("No");
  const [q2, setQ2] = useState("No");

  const [loading, setLoading] = useState(false);

  const [result, setResult] = useState<{
    ok: boolean;
    msg: string;
  } | null>(null);

  const check = async () => {
    try {
      if (getTokenExp()) {
        localStorage.clear();
        toast.error("Your login is expired!");
        setTimeout(() => {
          window.location.href = import.meta.env.VITE_LOGINURL;
        }, 2000);
        return false;
      }
      setLoading(true);

      const payload = {
        cigaretteSmoker: q1,
        otherTobaccoConsumption: q2,
      };

      const response = await API.CreateMethod("check-lifestyle-eligibility", payload);
      const decryptedResponse = decryptData(response?.data);

      if (response?.status == 200) {
        const data = decryptedResponse?.data;

        if (data?.eligible) {
          let msg = `✓ ${data?.message}`;

          if (data?.smokingQuestionnaireRequired) {
            msg += "";
          }

          setResult({
            ok: true,
            msg,
          });
        } else {
          setResult({
            ok: false,
            msg: `✕ ${data?.message}`,
          });
        }
      } else {
        setResult({
          ok: false,
          msg: "✕ Something went wrong.",
        });
      }
    } catch (error) {
      setResult({
        ok: false,
        msg: "✕ API Error. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (result !== null) {
      check();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q1, q2]);

  return (
    <>
      <label className="cc-label-normal">Do you smoke cigarettes every day?</label>

      <select value={q1} onChange={(e) => setQ1(e.target.value)}>
        <option>No</option>
        <option>Yes</option>
      </select>

      {q1 === "Yes" && (
        <div
          style={{
            marginTop: 8,
            padding: "10px 12px",
            background: "#fff7ed",
            border: "1.5px solid #fde68a",
            borderRadius: 8,
            fontSize: 13,
            color: "#b45309",
          }}
        >
          ℹ️ You would be required to fill a smoking questionnaire in proposal form.
        </div>
      )}

      <label className="cc-label-normal" style={{ marginTop: 16 }}>
        Do you consume tobacco in any other form?{" "}
        <span
          className="cc-tip"
          data-tip="This includes Bidis, Cigar, Mawa, Gutkha, Pan Masala, Betel leaf, Betel Nut, Chewing of Areca Nut etc."
        >
          i
        </span>
      </label>

      <select value={q2} onChange={(e) => setQ2(e.target.value)}>
        <option>No</option>
        <option>Yes</option>
      </select>

      {result && (
        <div className={`cc-elig-result cc-show ${result.ok ? "cc-elig-ok" : "cc-elig-fail"}`}>
          {result?.msg}
        </div>
      )}

      <button className="cc-btn cc-btn-amber" onClick={check} disabled={loading}>
        {loading ? "Checking..." : "Check Eligibility"}
      </button>
    </>
  );
}
